export class NotificationChimePlayer {
  #audio?: HTMLAudioElement;
  #initialized = false;

  constructor(private _src?: string) {}

  setSource(src?: string) {
    this._src = src;
    this.#initialized = false;
    this.#audio = undefined;
  }

  async play(): Promise<void> {
    try {
      if (this._src) {
        if (!this.#initialized) {
          this.#audio = new Audio(this._src);
          this.#audio.preload = 'auto';
          this.#initialized = true;
        }

        await this.#audio?.play();

        return;
      }
    } catch {
      // ignore playback errors (e.g. user gesture requirements)
    }
  }
}

export const notificationChimePlayer = new NotificationChimePlayer('/static/sounds/bolt-chime-new.mp3');
